<template>
  <div
    class="sidebar-item__container"
    :class="{ dark }"
  >
    <div
      class="sidebar-item__main"
      :class="{ open, dark }"
      @click="toggle"
    >
      <div
        :class="{
          'has-link': item.routeName,
          'router-link-active': item.routeName === $route.name,
        }"
        @click="goTo(item.routeName)"
      >
        {{ item.label }}
      </div>
    </div>
    <SidebarMotion :value="size">
      <div
        slot-scope="{ value }"
        :class="{ 'has-border': value > 10 && !dark }"
        :style="{ height: `${value}px` }"
      >
        <template v-for="child in item.children">
          <div
            v-if="!child.routeName"
            v-show="open || dark"
            :key="child.label"
            class="sidebar-item__child"
            :class="{ dark }"
            @click="showPermissionPending"
          >
            {{ child.label }}
          </div>
          <router-link
            v-else
            v-show="open || dark"
            :key="child.label"
            tag="div"
            :to="{ name: child.routeName, params: { isImage: child.zoomable } }"
            class="sidebar-item__child"
            :class="{ dark }"
            @click.native="$emit('click')"
          >
            {{ child.label }}
          </router-link>
        </template>
      </div>
    </SidebarMotion>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Motion } from 'vue-motion'

export default {
  name: 'SidebarItem',

  components: { SidebarMotion: Motion },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      open: false,
    }
  },

  computed: {
    ...mapState({
      dark: state => state.auth.dark,
    }),

    height() {
      const size = this.dark ? 15 : 30
      return this.item.children ? this.item.children.length * size : 0
    },

    size() {
      return this.open || this.dark ? this.height : 0
    },
  },

  methods: {
    ...mapActions({
      showPermissionPending: 'auth/showPermissionPending',
    }),

    goTo(routeName) {
      if (!routeName) {
        return
      }

      this.$router.push({ name: routeName })
    },

    toggle() {
      if (this.dark) {
        return
      }
      this.open = !this.open
    },
  },
}
</script>

<style lang="postcss" scoped>
.sidebar-item {
  &__container {
    font-family: 'univia-pro';
    font-size: 18px;
    @apply text-blue mb-4;

    &.dark {
      font-family: 'vox';
      font-size: 16px;
    }
  }

  &__main {
    font-size: 18px;
    @apply mb-4 uppercase px-4 py-1;

    &.dark {
      @apply mb-0 mt-2;
    }

    &:not(.dark) {
      @apply cursor-pointer;
    }

    &:not(.dark):hover {
      @apply bg-blue text-blue-lighter;
    }

    &.dark .has-link:hover,
    &.dark .router-link-active {
      @apply text-blue-lighter cursor-pointer;
    }
  }

  &__child {
    font-size: 12px;
    @apply px-4 my-2 cursor-pointer;

    &.dark {
      @apply my-1 pl-8 uppercase;
    }

    &:hover,
    &.router-link-active {
      @apply text-blue-lighter;
    }
  }
}

.open {
  @apply mb-0 bg-blue text-blue-lighter;
}

.has-border {
  @apply border-b-2 border-blue pb-2;
}
</style>
